import { render } from "./Accommodation.vue?vue&type=template&id=36c0d271&scoped=true"
import script from "./Accommodation.vue?vue&type=script&lang=js"
export * from "./Accommodation.vue?vue&type=script&lang=js"

import "./Accommodation.vue?vue&type=style&index=0&id=36c0d271&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c0d271"]])

export default __exports__